import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import AppLoading from "../app-loading/app-loading";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import RawMaterialMovementSearch from "./rawMaterial-movement-search";
import { RawMaterialMovementLogTable } from "./RawMaterial-movement-log";
import { RawMaterialMovementSummary } from "./RawMaterial-movement-summary";

const RawMaterialMovementMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [loading, setLoading] = useState(false);
  const [logData, setLogData] = useState<any[]>([]);
  const [summaryData, setSummaryData] = useState<any[]>([]);
  const [keyword, setKeyword] = useState<string>("");
  const [activeTab, setActiveTab] = useState<'movement' | 'summary'>('movement');
  
  // Refs for table components to call resetFilters
  const movementLogTableRef = useRef<{ resetFilters: () => void }>(null);
  const summaryTableRef = useRef<{ resetFilters: () => void }>(null);
  
  // Callback to reset filters in both tables
  const handleResetFilters = () => {
    movementLogTableRef.current?.resetFilters();
    summaryTableRef.current?.resetFilters();
    setKeyword("");
  };
  
  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-right" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          {/* Filter Section (includes header) */}
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <RawMaterialMovementSearch  
                setLoading={setLoading}  
                onSearch={(data) => setLogData(data)} 
                onSummary={(data) => setSummaryData(data)}
                onReset={handleResetFilters}
                onKeywordChange={(kw) => setKeyword(kw)}
              />
            </div>
          </div>

          {/* Custom Tab Buttons */}
          <div className="col-12">
            <div className="flex gap-2 mb-2">
              <Button
                label="Movement Log"
                icon="pi pi-list"
                className="custom-tab-button"
                style={{
                  backgroundColor: activeTab === 'movement' ? 'rgb(76, 175, 80)' : 'transparent',
                  color: activeTab === 'movement' ? 'white' : 'rgb(76, 175, 80)',
                  border: '1px solid rgb(76, 175, 80)',
                  borderRadius: '6px',
                  padding: '0.5rem 1rem',
                  transition: 'all 0.3s ease',
                  fontWeight: activeTab === 'movement' ? '600' : '500'
                }}
                onClick={() => setActiveTab('movement')}
              />
              <Button
                label="Summary View"
                icon="pi pi-chart-bar"
                className="custom-tab-button"
                style={{
                  backgroundColor: activeTab === 'summary' ? 'rgb(76, 175, 80)' : 'transparent',
                  color: activeTab === 'summary' ? 'white' : 'rgb(76, 175, 80)',
                  border: '1px solid rgb(76, 175, 80)',
                  borderRadius: '6px',
                  padding: '0.5rem 1rem',
                  transition: 'all 0.3s ease',
                  fontWeight: activeTab === 'summary' ? '600' : '500'
                }}
                onClick={() => setActiveTab('summary')}
              />
            </div>
          </div>

          {/* Tab Content */}
          <div className="col-12">
            {activeTab === 'movement' && (
              <RawMaterialMovementLogTable 
                ref={movementLogTableRef}
                data={logData} 
                loading={loading}
                keyword={keyword}
              />
            )}
            {activeTab === 'summary' && (
              <RawMaterialMovementSummary 
                ref={summaryTableRef}
                data={summaryData} 
                loading={loading}
                keyword={keyword}
              />
            )}
          </div>
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default RawMaterialMovementMain;